import React from 'react';
import { Card, Skeleton, Space } from 'antd';

export const ProcessSkeleton = ({ title = 'Процессы', hasBreadcrumbs = false }) => {
  return (
    <div className="process-skeleton-wrap" style={{ width: '100%', marginTop: 8 }}>
      {/* Optional Breadcrumbs */}
      {hasBreadcrumbs && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
          <Skeleton.Input active size="small" style={{ width: 30, height: 14, borderRadius: 2 }} />
          <span>/</span>
          <Skeleton.Input active size="small" style={{ width: 90, height: 14, borderRadius: 2 }} />
          <span>/</span>
          <Skeleton.Input active size="small" style={{ width: 110, height: 14, borderRadius: 2 }} />
        </div>
      )}

      {/* Header: Title + Add Button */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          flexWrap: 'wrap',
          gap: 12,
        }}
      >
        <Skeleton.Input active style={{ width: 200, height: 28, borderRadius: 4 }} />
        <Skeleton.Button active style={{ width: 170, height: 38, borderRadius: 6 }} />
      </div>

      {/* Process Tree Table */}
      <Card
        bordered={false}
        style={{
          borderRadius: 8,
          border: '1px solid #eaedf1',
          overflow: 'hidden',
          background: '#ffffff',
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #eaedf1',
            padding: '12px 18px',
            gap: 12,
          }}
        >
          <div style={{ width: '10%' }}><Skeleton.Input active size="small" style={{ width: 24, height: 14 }} /></div>
          <div style={{ width: '60%' }}><Skeleton.Input active size="small" style={{ width: '40%', height: 14 }} /></div>
          <div style={{ width: '15%' }}><Skeleton.Input active size="small" style={{ width: '50%', height: 14 }} /></div>
          <div style={{ width: '15%' }}><Skeleton.Input active size="small" style={{ width: '40%', height: 14 }} /></div>
        </div>

        {Array.from({ length: 6 }).map((_, idx) => (
          <div
            key={'proc_row_' + idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '14px 18px',
              borderBottom: idx === 5 ? 'none' : '1px solid #f1f5f9',
              backgroundColor: idx % 2 === 1 ? '#fafbfc' : '#ffffff',
              gap: 12,
            }}
          >
            <div style={{ width: '10%' }}>
              <Skeleton.Input active size="small" style={{ width: 20, height: 14, borderRadius: 2 }} />
            </div>
            <div style={{ width: '60%', display: 'flex', alignItems: 'center', gap: 10 }}>
              <Skeleton.Button active size="small" shape="circle" style={{ width: 16, height: 16 }} />
              <Skeleton.Input active size="small" style={{ width: '' + (40 + (idx * 8) % 40) + '%', height: 15, borderRadius: 3 }} />
            </div>
            <div style={{ width: '15%' }}>
              <Skeleton.Button active size="small" style={{ width: 60, height: 22, borderRadius: 10 }} />
            </div>
            <div style={{ width: '15%' }}>
              <Space size="small">
                <Skeleton.Button active size="small" shape="circle" style={{ width: 24, height: 24 }} />
                <Skeleton.Button active size="small" shape="circle" style={{ width: 24, height: 24 }} />
              </Space>
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
};

export default ProcessSkeleton;

